// Lodash
window._ = require('lodash');

// Bootstrap
try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js');
    require('bootstrap');
} catch (error) {
    console.log(error)
}

// Owl
require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel/dist/assets/owl.theme.default.min.css')
require('owl.carousel');

// Validator
require('jquery-validation');